import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import TextField from "@mui/material/TextField";
import * as React from "react";
import { applicationInfoType } from "types/app";
import API from "@/api/serverCall";
import { useSnackbar } from "notistack";
import getOrganizationInfoRequestThunk from "@/redux/organization/thunk";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

interface IDeleteDialogBodyProps {
	ApplicationInfo: applicationInfoType[];
	handleModalClose: () => void;
	ApplicationItem: applicationInfoType;
	setApplicationInfo: (value: applicationInfoType[]) => void;
}

const DeleteDialogBody: React.FC<IDeleteDialogBodyProps> = ({
	handleModalClose,
	ApplicationItem,
	setApplicationInfo,
	ApplicationInfo,
}) => {
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const { enqueueSnackbar } = useSnackbar();
	const [deleteAppName, setDeleteAppName] = React.useState("");
	const deleteAppFunc = () => {
		// loading
		try {
			API.DELETE<string>({
				link: `/app/${ApplicationItem.id}`,
			}).then((response) => {
				setApplicationInfo(
					ApplicationInfo.filter((id) => id !== ApplicationItem),
				);
				dispatch(getOrganizationInfoRequestThunk());
				handleModalClose();
				enqueueSnackbar(t("application_delete.success"), {
					variant: "info",
				});
			});
		} catch (error) {
			console.error(error);
		}
	};

	return (
		<DialogContent sx={{ padding: "2rem 2rem" }}>
			<div style={{ margin: "1rem 0 3rem 0" }}>
				<span>
					{t("application_delete.guide")}
					<span style={{ color: "#df2222" }}>{ApplicationItem.name}</span>
				</span>
				<TextField
					id="outlined-basic"
					variant="outlined"
					size="medium"
					// disabled={true}
					value={deleteAppName}
					placeholder={ApplicationItem.name}
					fullWidth={true}
					onChange={(e) => {
						setDeleteAppName(e.target.value);
					}}
				/>
			</div>
			<div
				style={{
					display: "flex",
					justifyContent: "flex-end",
					marginTop: "1rem",
				}}
			>
				<Button
					variant="outlined"
					sx={{
						color: "#747474",
						borderColor: "#747474",
						marginRight: "0.5rem",
					}}
					onClick={handleModalClose}
				>
					{t("application_delete.cancel")}
				</Button>
				<Button
					variant="contained"
					sx={{ backgroundColor: "#2453F9", color: "white" }}
					onClick={deleteAppFunc}
					disabled={deleteAppName !== ApplicationItem.name}
				>
					{t("application_delete.delete")}
				</Button>
			</div>
		</DialogContent>
	);
};
export default DeleteDialogBody;
